export default {
  eyebrow: '',
  heading: 'Neque ua porro quisq uam dolom',
  copy:
    'Lorem ipsum dolor sit amet, consectetur adipiscing elit. Sed sit amet magna sed lacus maximus dictum eget eu lectus. Class aptent taciti sociosqu ad litora torquent per conubia nostra, per inceptos himenaeos.\n\n' +
    'Maecenas tempor nunc in commodo suscipit. Nullam non tellus est. Nulla facilisi. Sed sapien mi, condimentum ac blandit ut, pretium id metus. Phasellus interdum placerat odio ac convallis. Proin vehicula finibus volutpat. Aenean quam velit, congue in maximus molestie, accumsan in nisl. Curabitur vitae tortor magna. Duis dapibus auctor augue.',
  image: {
    alt: 'Image showing a person holding a pencil',
    filename:
      '//a.storyblok.com/f/46530/4195x2802/0bd806df69/joshua-sortino-lqkhndzsf-8-unsplash-1.jpg',
  },
  cta: [],
  battenberg: [
    {
      title: 'Tribal Health',
      square_1: { color: 'transparent' },
      square_2: { color: '#FFFFFF' },
      square_3: { color: 'transparent' },
      square_4: { color: '#FFFFFF' },
      square_5: { color: 'transparent' },
      square_6: { color: 'transparent' },
      square_7: { color: 'transparent' },
      square_8: { color: '#FFFFFF' },
      square_9: { color: '#FFFFFF' },
      component: 'a-svg-logo-x9',
    },
  ],
  component: 'o-health-x1-sq',
}
